export default "__VITE_ASSET__CousCnDa__"